import { Components } from '@mui/material';

export const breadscrumbs: Components = {
  MuiBreadcrumbs: {
    styleOverrides: {
      li: {
        fontSize: '16px',
      },
    },
  },
};
